var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-custom',{attrs:{"action":_vm.hide,"padding":"s"}},[_vm._v("\n  "+_vm._s(_vm.$l.close)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }